import { lazy } from 'react';

export const SettingsAppraiserPageAsync = lazy(
    () => import('./SettingsAppraiserPage'),
);
